import Header from "../header"
import "./index.css"
import TaskBar from "../taskbar";
import CopyRight from "../copyright";

const CountrieUk = () => {

    return (
        <>
        <Header />
        <div className="container-head">
          <h1>Why Choose United Kingdom as Your Study Destination?</h1>  
          <p>The United Kingdom is globally recognized for its academic excellence, cultural richness, and welcoming environment for international students.  </p>
        <p>Key Advantages:  </p>
        <ul>
            <li> Globally recognized qualifications from top-ranked universities  </li>
           <li>Shorter course durations, reducing time and tuition costs </li>
           <li>Access to free healthcare via the National Health Service (NHS) </li>
           <li>Part-time work opportunities during study </li>
           <li>Dynamic multicultural environment </li>
           <li>Industry-aligned courses enhancing employability  </li>
        </ul>

        <hr />
        <table>
            <caption>Understanding the UK Higher Education System </caption>
            <thead>
                <tr>
                    <th>Category</th>
                    <th>Details</th>
                </tr>
            </thead>
                <tr>
                    <td>Ancient Universities</td>
                    <td>Historic institutions (e.g., Oxford, Cambridge) with a tradition of excellence </td>
                </tr>
                <tr>
                    <td>Red Brick Universities </td>
                    <td>Established during the industrial era, strong focus on research (e.g., Manchester) </td>
                </tr>
        </table>
        

        <hr />

        <h2>Modern Universities Industry-focused programs, cutting-edge facilities</h2>

         <table>
            <thead>
                <tr>
                    <th>Aspect </th>
                    <th>Undergraduate Studies </th>
                    <th>Postgraduate Studies </th>
                </tr>
            </thead>
                <tr>
                    <td>Qualification</td>
                    <td>Bachelor's Degree (Honours)  </td>
                    <td>Master's Degree (Taught/Research)  </td>
                </tr>
                <tr>
                    <td>Duration</td>
                    <td>3 years (standard) / 4 years (with placement) </td>
                    <td>1 year (taught) / 2 years (research - based)  </td>
                </tr>
                <tr>
                    <td>Credit Load</td>
                    <td>120 credits per academic year</td>
                    <td>180 credits over 12 months  </td>
                </tr>
                <tr>
                    <td>Entry Requirements</td>
                    <td>12th-grade completion or equivalent </td>
                    <td>Relevant Bachelor's degree  </td>
                </tr>
                <tr>
                    <td>Focus </td>
                    <td>Foundation knowledge and skill development </td>
                    <td>Specialized expertise and research  </td>
                </tr>
                <tr>
                    <td>Assessment Methods</td>
                    <td>Exams, essays, projects, presentations</td>
                    <td>Coursework, exams, dissertation/thesis  </td>
                </tr>
                <tr>
                    <td>Placement Opportunities </td>
                    <td>Available in sandwich courses</td>
                    <td>Available in MBA, STEM, and select programs  </td>
                </tr>    
        </table>
        <hr />
        <h2>UK Admission Timeline</h2>
        <table>
            <thead>
                <tr>
                    <th>Intake</th>
                    <th>Description </th>
                </tr>
            </thead>
                <tr>
                    <td>September </td>
                    <td>Main and largest intake with most options</td>
                </tr>
                <tr>
                    <td>January</td>
                    <td>Wide range of programs available </td>
                </tr>
                <tr>
                    <td>May</td>
                    <td>Limited postgraduate courses only </td>
                </tr>
                </table>
                <p>Tip: Apply early to maximize chances for scholarships and visa approvals! </p>
                <hr/>
                <h2>Admission Requirements</h2>
            <table>
            <thead>
                <tr>
                    <th>Study Level </th>
                    <th>Academic Qualification </th>
                    <th>English Proficiency</th>
                    <th>Supporting Documents </th>
                </tr>
            </thead>
                <tr>
                    <td>Undergraduate</td>
                    <td>Class X & XII with minimum 60% </td>
                    <td>IELTS, PTE, Duolingo (or equivalent)  </td>
                    <td>SOP, LORs, Resume, Passport</td>
                </tr>
                <tr>
                    <td>Postgraduate</td>
                    <td>Class X, XII, Bachelor's with 55% </td>
                    <td>IELTS, PTE, Duolingo (or equivalent) </td>
                    <td>SOP, LORs, Resume, Passport, Work Experience (if applicable) </td>
                </tr>
                </table>
            <hr />
            <h2>Estimated Costs for Studying in the UK  </h2>
            <table>
            <thead>
                <tr>
                    <th>Expense Type </th>
                    <th>Amount </th>
                </tr>
            </thead>
                <tr>
                    <td>Tuition Fees (UG) </td>
                    <td>£10,000 – £20,000 per year </td>
                </tr>
                <tr>
                    <td>Tuition Fees (PG) </td>
                    <td>£11,000 – £25,000 per year </td>
                </tr>
                <tr>
                    <td>Living Expenses (London)  </td>
                    <td>£1,483 per month (up to 9 months) </td>
                </tr>
                <tr>
                    <td>Living Expenses (Outside London)</td>
                    <td>£1,136 per month (up to 9 months) </td>
                </tr>
                <tr>
                    <td>Student Visa Fee</td>
                    <td>£524 </td>
                </tr>
                <tr>
                    <td>Dependent Visa Fee</td>
                    <td>£348 per applicant </td>
                </tr>
                </table>
                <p>Note: Tuition fees often payable in two installments: before visa and after arrival. </p>
            <hr />
            <h2>Scholarships to Support Your Study Journey </h2>
            <p> Many UK universities offer scholarships based on academic merit, leadership, and financial need. At 
Dream Destination, we help you identify and apply for scholarships to lower your overall study 
expenses.  </p>

           <hr />

           <h2>UK Admission & Visa Documentation </h2>
           <p>For University Admission: </p>
           <ul>
            <li>Academic transcripts (Class 10, 12, Bachelor's degree) </li>
            <li>English proficiency test scores (IELTS/PTE/Duolingo) </li>
            <li>Statement of Purpose (SOP) </li>
            <li>Letters of Recommendation (LORs) </li>
            <li>Resume/CV </li>
            <li>Passport</li>
            <li>Work experience certificates (if applicable) </li>
           </ul>
            <p>For Visa Application: </p>
            <ul>
                <li>Valid Passport </li>
                <li>CAS (Confirmation of Acceptance for Studies) letter</li>
                <li>Proof of funds (tuition + living costs)</li>
                <li>Academic documents </li>
                <li>English proficiency proof </li>
                <li>Tuberculosis (TB) test certificate (if applicable) </li>
                <li>Visa application and fee receipt </li>
                <li>Immigration Health Surcharge (IHS) payment proof </li>
                <li>Passport-sized photographs</li>
            </ul>
            <hr/>
            <h2>Postgraduate Courses with Work Placements </h2>
            <p>Many UK universities offer Master’s programs with integrated internships or placement years, offering: </p>
            <ul>
                <li>Real-world work experience </li>
                <li>Enhanced resume strength </li>
                <li>Higher employability chances post-study </li>
            </ul>
            <hr/>
            <h2>Graduate Immigration Route (Post-Study Work Visa) </h2>
            <p>After graduation: </p>
            <ul>
                <li>Bachelor's & Master's graduates: 2 years stay </li>
                <li>Ph.D. graduates: 3 years stay </li>
            </ul>
            <p>Use this opportunity to work full-time and build international experience. </p>
        </div>
        <TaskBar />
        <CopyRight />
        </>
    )

}

export default CountrieUk